/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React, { type Ref } from 'react';
import { MENU_ID_CUSTOMER_SERVICE } from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import {
	L1_MENU_ID,
	type Nav4DragAndDropMenuItemProps,
} from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import { Nav4MenuLinkItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/nav4-menu-link-item/index.tsx';
import { useConfigurableMessageAndIconMap } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/controllers/use-configurable-message-and-icon-map/index.tsx';
import { HideL1MenuItemSection } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/hide-l1-menu-item-action/index.tsx';
import { MoreNavMenuButton } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/more-nav-menu-button/main.tsx';
import { MENU_ID_ANALYTIC_EVENT_IDS } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/side-nav.tsx';
import { getMenuItemAnalytics } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/utils/get-analytics-attributes/index.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { componentWithFG } from '@jira/platform__utils-feature-gates-gate-component';
import MenuGroup from '@atlaskit/menu/menu-group';

export const CUSTOMER_SERVICE_HREF = '/jira/helpcenter';

interface Props extends Nav4DragAndDropMenuItemProps {}

export const CustomerServiceMenuLinkItem: React.FC<Props & React.RefAttributes<unknown>> =
	componentWithFG(
		'navx-global-side-nav',
		CustomerServiceMenuLinkItemNEW,
		CustomerServiceMenuLinkItemOLD,
	);

function CustomerServiceMenuLinkItemNEW(props: Props): React.JSX.Element {
	const { draggableRef, dropIndicator, hasDragIndicator, isDragging, visualContentRef } = props;
	const { formattedMessage, icon } = useConfigurableMessageAndIconMap(L1_MENU_ID.CUSTOMER_SERVICE);
	// oxlint-disable-next-line typescript/consistent-type-assertions
	const ref = draggableRef as Ref<HTMLAnchorElement> | undefined;

	const analytics = getMenuItemAnalytics({
		actionSubjectId: MENU_ID_ANALYTIC_EVENT_IDS[MENU_ID_CUSTOMER_SERVICE],
		itemId: 'customer-experiences',
		level: 1,
	});

	return (
		<Nav4MenuLinkItem
			analytics={analytics}
			dropIndicator={dropIndicator}
			elemBefore={icon}
			hasDragIndicator={hasDragIndicator}
			href={CUSTOMER_SERVICE_HREF}
			isDragging={isDragging}
			menuId={MENU_ID_CUSTOMER_SERVICE}
			ref={ref}
			visualContentRef={visualContentRef}
		>
			{formattedMessage}
		</Nav4MenuLinkItem>
	);
}

function CustomerServiceMenuLinkItemOLD(): React.JSX.Element {
	const { formattedMessage, icon } = useConfigurableMessageAndIconMap(L1_MENU_ID.CUSTOMER_SERVICE);

	const analytics = getMenuItemAnalytics({
		actionSubjectId: MENU_ID_ANALYTIC_EVENT_IDS[MENU_ID_CUSTOMER_SERVICE],
		itemId: 'customer-experiences',
		level: 1,
	});

	return (
		<Nav4MenuLinkItem
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure
			testId="navigation-apps-sidebar-nav4-sidebars-content-customer-service.ui.sidenav-customer-service"
			href={CUSTOMER_SERVICE_HREF}
			menuId={MENU_ID_CUSTOMER_SERVICE}
			elemBefore={icon}
			actionsOnHover={<MoreNavMenuButton MenuItems={MenuItems} name={formattedMessage} />}
			analytics={analytics}
		>
			{formattedMessage}
		</Nav4MenuLinkItem>
	);
}

const MenuItems = () => (
	<MenuGroup>
		<HideL1MenuItemSection menuId={MENU_ID_CUSTOMER_SERVICE} hasSeparator={false} />
	</MenuGroup>
);
